pageId = 'page-users-mobile-verifiers-new'
page = '#' + pageId

$ ->
  initMobileVerificationForm $(page)

  tower.stack.on 'pageload', (e, $page, page) ->
    initMobileVerificationForm $page


initMobileVerificationForm = ($page) ->
  $mobileVerifierForm = $page.find '.mobile-verifier-form'
  if $mobileVerifierForm.length > 0
    tower.initMobileVerification $mobileVerifierForm